import request from "./request";

// 查询引力表格数据
export const getGravitationTable = () => request("/sysPara/selectParaList", null, "GET");
// 新增引力数据
export const addGravitationData = (data) => request("/sysPara/saveGravityPara", data, "POST_JSON");
// 修改引力数据
export const modifyGravitationData = (data) => request("/sysPara/updateGravityPara", data, "POST_JSON");